import React from 'react'
import styled from "styled-components"
import Bobby from './Images/Bobby.jpeg'
import Gori from './Images/Gori.jpeg' 
import Lael from './Images/Lael.jpeg'
import Naza from './Images/Naza.jpeg'
import Samod from './Images/Samod.jpeg'
import Okunnu from './Images/Ife Okunnu - Ife Okunnu.jpg'
import Iyanu from './Images/20220605_163921525 - Iyanu Owoyele.jpg'



function Ace() {
    return (
        <div>
            <h1>TEAM ACE</h1>
            <h3>OWNER: Elon Etherprince </h3>
            <br/>
            <Div>
                <div><Img src={Okunnu}/> Ife Okunnu</div><br/>
                <div><Img src={Bobby}/> Bobby Deniro</div><br/>
                <div><Img src={Gori}/> Adeloye Goriola</div><br/>
                <div><Img src={Lael}/> Lael Butler</div><br/>
                <div><Img src={Naza}/> Ekeala Naza</div><br/>
                <div><Img src={Samod}/> Sogunro Samod</div><br/>
                <div><Img src={Iyanu}/> Owoyele Iyanu</div><br/>
            </Div>
    
            
        </div>
      )
}

export default Ace

const Img = styled.img`
height: 300px;
width: 300px;
@media screen and (max-width: 750px) {
  height: 150px;
  width: 150px;
}
`

const Div = styled.div`
font-size: 20px;
font-weight: bold;
`